"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW = '@redux-modal/SHOW';
exports.HIDE = '@redux-modal/HIDE';
exports.DESTROY = '@redux-modal/DESTROY';